import React from 'react'

import { FormikValues } from 'formik'

import { DirectoryOption } from './'
import { SelectField } from '@/components/FormikInputs'
import InputField from '@/components/FormikInputs/v3/InputField'
import { Step } from '@/components/Stepper'
import { Company } from '@/types/unlock'

interface DirectoryModeStepProps {
  values: FormikValues
  selectedType: string
  directoryOptions: DirectoryOption[]
  companies: Company[]
}

export const DirectoryModeStep = ({
  values,
  directoryOptions,
  selectedType,
  companies,
}: DirectoryModeStepProps): Step => {
  return {
    title: 'Select Contact',
    content: () => (
      <>
        {directoryOptions.length > 0 ? (
          <div className='flex flex-col w-full gap-3'>
            <SelectField
              style='default'
              name='directory_name'
              options={directoryOptions}
              disabled={!selectedType}
              placeholder='Select Company…'
              showError={false}
            />
            {values?.directory_name && (
              <>
                <InputField
                  name='manual_name'
                  placeholder='Company Name'
                  style='default'
                  value={
                    directoryOptions.find((it) => it.value === values.directory_name)?.label || ''
                  }
                  showError={false}
                  disabled
                />
                <InputField
                  name='contact_name'
                  placeholder='Contact Name'
                  style='default'
                  showError={false}
                  value={
                    companies.find((it) => it.uuid === values.directory_name)?.contact_name || ''
                  }
                  disabled
                />
                <InputField
                  name='phone'
                  placeholder='Phone'
                  parentClassName='w-full'
                  style='default'
                  value={companies.find((it) => it.uuid === values.directory_name)?.phone || ''}
                  showError={false}
                  disabled
                />
                <InputField
                  name='email'
                  placeholder='E-mail'
                  parentClassName='w-full'
                  style='default'
                  value={companies.find((it) => it.uuid === values.directory_name)?.email || ''}
                  disabled
                />
                <InputField
                  name='address'
                  placeholder='Address'
                  parentClassName='w-full'
                  style='default'
                  value={companies.find((it) => it.uuid === values.directory_name)?.address || ''}
                  showError={false}
                  disabled
                />
              </>
            )}
          </div>
        ) : values.contact_type ? (
          <p className='my-4 text-sm'>No records of this type in the directory</p>
        ) : null}
      </>
    ),
    buttonLabel: 'Next',
    disabledStep: !values.contact_type || !values.currentMode,
    hideButton: true,
  }
}
